import React from 'react';
import PropTypes from 'prop-types';
import './Heading.scss';
var Heading = function Heading(_ref) {
    var text = _ref.text,
        children = _ref.children;

    return React.createElement(
        'h1',
        { className: 'mb-0 heading' },
        text || children
    );
};

Heading.defaultProps = {

    text: "Heading"
};

Heading.propTypes = process.env.NODE_ENV !== "production" ? {

    /**
     * Heading text
     */
    text: PropTypes.string, //deprecated
    children: PropTypes.node //text

} : {};

export default Heading;